/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Head from "next/head";

import { ApplyBlock } from "src/components/Splash/ApplyBlock";
import { LDFooter as Footer } from "src/components/Splash/Footer";
import { JobPostHeader } from "src/components/Splash/Header";
import { LDPageContainer as PageContainer } from "src/components/Splash/Layout/PageContainer";
import {
  LDBlockHeading as BlockHeading,
  LDBlockParagraph as BlockParagraph,
  LDBlockUL as BlockUL,
  LDBlockSubheading as BlockSubheading,
} from "src/components/Splash/Layout/Typography";
import { LDBlock as Block } from "src/components/Splash/LDBlock";

export default function Frontend() {
  return (
    <>
      <Head>
        <title>Frontend Engineer - Jobs - Vienna Hypertext</title>
      </Head>
      <main>
        <PageContainer>
          <JobPostHeader jobTitle="Frontend" />
          <ApplyBlock />
          <Block>
            <BlockHeading>Frontend Engineer</BlockHeading>
            <BlockSubheading>About the role</BlockSubheading>
            <BlockParagraph>
              You will be a React engineer. You’ll craft beautiful components and arrange them to build an insanely
              great user experience. Our goal is nothing less than to build an advanced thought network on top of
              the internet. We are seeking people who want to use their technical skills to push the boundaries of
              what is possible on the web.
            </BlockParagraph>
            <BlockParagraph>
              For example, our app must be able to handle <i>very</i> large pages in a performant way. Delivering a
              rich and snappy user experience on a page that has tens of thousands of networked objects is hard,
              and standard frontend strategies have been inadequate.
            </BlockParagraph>
            <BlockParagraph>
              Unlike many startups, we aren’t interested in someone who will translate business logic into React
              components. We are seeking energetic software engineers, who want to build the future of the
              internet.
            </BlockParagraph>
            <BlockParagraph>
              In addition to your main engineering responsibilities, you might be interested in working with us if
              you share an interest in design, aesthetics, or the history of ideas, especially the early internet.
            </BlockParagraph>
            <BlockSubheading>Qualifications</BlockSubheading>
            <BlockUL>
              <li>Fluent in Javascript/Typescript</li>
              <li>Hyper-fluent in React</li>
              <li>You have designed and built applications or other cool things</li>
              <li>No bad vibes</li>
            </BlockUL>
            <BlockSubheading>Bonus Points</BlockSubheading>
            <BlockUL>
              <li>WebGL</li>
              <li>Next.js</li>
              <li>Good vibes</li>
              <li>Strong or original views</li>
            </BlockUL>
            <BlockSubheading>Location</BlockSubheading>
            <BlockParagraph>
              We have a very strong preference for in-person work in NYC. With that said, we are open to discussing
              remote on a case-by-case basis.
            </BlockParagraph>
            <BlockSubheading>Compensation</BlockSubheading>
            <BlockParagraph>Combo salary+equity, very competitive</BlockParagraph>
          </Block>
          <ApplyBlock />
          <Footer />
        </PageContainer>
      </main>
    </>
  );
}
